export default {
  headline: 'Benvenuto',
  welcomeText: process.env.VUE_APP_WELCOME_TEXT_EN ||
  'al sistema di gestione dell\'apprendimento di innovation mecom.'
}
